import { enUS, es, ptBR } from 'date-fns/locale';

export const LOCALES = { en: enUS, es, ptBR, 'pt-BR': ptBR, 'es-AR': es, 'es-NI': es };
